module.exports = __webpack_public_path__ + "static/img/icon-access.a50a919f.svg";